export const BASE_API = `https://smoggy-tweed-jacket-goat.cyclic.app`;
// export const BASE_API = `http://127.0.0.1:3000`;
